import { Drawer } from 'antd';
import {
  getCompareStaticticsReportExel,
  getFetchBaseLineSurveyIds,
  getFetchProgressSurveyIds,
} from 'clients/dashboardClients';
import { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import { useApiLoaderStore } from 'store/apiLoderStore';
import { useFilterStore } from 'store/filterStore';
import { useNewStore } from 'store/newStore';
import { useToastStore } from 'store/toastStore';
import styles from './exportFileDialogue.module.scss';
type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  startDate: any;
  endDate: any;
};
function CompareStatisticsReportDrawer(props: Props) {
  const { isOpen, setIsOpen, startDate, endDate } = props;
  const [
    distinctGrades,
    lowerLimit,
    higherLimit,
    selectedDataSouce,
    baselineSurveyIds,
    progressSurveyIds,
    setBaseLineSurveyIds,
    setProgressSurveyIds,
    setDistinctGrades,
  ] = useNewStore((state) => [
    state.distinctGrades,
    state.lowerLimit,
    state.higherLimit,
    state.selectedDataSouce,
    state.baselineSurveyIds,
    state.progressSurveyIds,
    state.setBaseLineSurveyIds,
    state.setProgressSurveyIds,
    state.setDistinctGrades,
  ]);
  const filterDto = useFilterStore((state) => state.filterDto);
  const showLoader = useApiLoaderStore((state) => state.showLoader);
  const showToast = useToastStore((state) => state.showToast);
  const [gradeOptions, setGradeOptions] = useState<any>(null);
  const [subjectOptions, setSubjectOptions] = useState<any>(null);
  const [selectedGrade, setSelectedGrade] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedBaselineSurveyId, setSelectedBaselineSurveyId] =
    useState<any>('');
  const [selectedProgressSurveyId, setSelectedProgressSurveyId] =
    useState<any>('');
  useEffect(() => {
    if (distinctGrades && distinctGrades.keys()) {
      const gradeArray = Array.from(distinctGrades.keys()).map((key: any) => ({
        label: key,
        value: key,
      }));
      setGradeOptions(gradeArray);
    }
  }, [distinctGrades, setGradeOptions]);
  useEffect(() => {
    if (distinctGrades && selectedGrade && distinctGrades.get(selectedGrade)) {
      const subjectArray = Array.from(
        distinctGrades.get(selectedGrade).keys()
      ).map((key: any) => ({
        label: key,
        value: key,
      }));
      setSubjectOptions(subjectArray);
    }
  }, [distinctGrades, setSubjectOptions, selectedGrade]);
  useEffect(() => {
    setSelectedBaselineSurveyId('');
    setSelectedProgressSurveyId('');
    setBaseLineSurveyIds(null);
    setProgressSurveyIds(null);
  }, [
    setSelectedBaselineSurveyId,
    setSelectedProgressSurveyId,
    setBaseLineSurveyIds,
    setProgressSurveyIds,
    selectedGrade,
    selectedSubject,
  ]);
  useEffect(() => {
    if (distinctGrades && selectedGrade && selectedSubject) {
      const body = {
        selectedSessionNames: filterDto ? filterDto.selectedSessionNames : [],
        selectedCountries: filterDto ? filterDto.selectedCountries : [],
        selectedStates: filterDto ? filterDto.selectedStates : [],
        selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
        selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
        selectedClusters: filterDto ? filterDto.selectedClusters : [],
        selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
        selectedSchoolIds: filterDto ? filterDto.selectedSchoolIds : [],
        selectedGrades: filterDto ? filterDto.selectedGrades : [],
        lowerLimit: lowerLimit,
        upperLimit: higherLimit,
        startDate: startDate.unix(),
        endDate: endDate.unix(),
        dataSource: selectedDataSouce,
        grade: selectedGrade,
        subject: selectedSubject,
      };
      getFetchBaseLineSurveyIds(body, showToast).then((response) => {
        if (response) {
          const ids = response.map((key: any) => ({
            label: key,
            value: key,
          }));
          setBaseLineSurveyIds(ids);
        }
      });
      getFetchProgressSurveyIds(body, showToast).then((response) => {
        if (response) {
          const ids = response.map((key: any) => ({
            label: key,
            value: key,
          }));
          setProgressSurveyIds(ids);
        }
      });
    }
  }, [
    distinctGrades,
    selectedGrade,
    selectedSubject,
    filterDto,
    showToast,
    setBaseLineSurveyIds,
    setProgressSurveyIds,
    startDate,
    endDate,
    selectedDataSouce,
  ]);
  function onClose() {
    setIsOpen(false);
  }
  function onDownloadButtonClicked() {
    if (
      selectedBaselineSurveyId.length === 0 &&
      selectedProgressSurveyId.length === 0
    ) {
      showToast({
        theme: 'error',
        message: 'Please select both surveyIds to download reports.',
        autoClose: true,
      });
      return;
    }
    // onClose();
    const body = {
      selectedSessionNames: filterDto ? filterDto.selectedSessionNames : [],
      selectedCountries: filterDto ? filterDto.selectedCountries : [],
      selectedStates: filterDto ? filterDto.selectedStates : [],
      selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
      selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
      selectedClusters: filterDto ? filterDto.selectedClusters : [],
      selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
      selectedSchoolIds: filterDto ? filterDto.selectedSchoolIds : [],
      selectedGrades: filterDto ? filterDto.selectedGrades : [],
      lowerLimit: lowerLimit,
      upperLimit: higherLimit,
      startDate: startDate.unix(),
      endDate: endDate.unix(),
      dataSource: selectedDataSouce,
      grade: selectedGrade,
      subject: selectedSubject,
      baselineSurveyId:
        selectedBaselineSurveyId.length > 0
          ? selectedBaselineSurveyId.map((element: any) => element.value)
          : [],
      progressSurveyId:
        selectedProgressSurveyId.length > 0
          ? selectedProgressSurveyId.map((element: any) => element.value)
          : [],
    };
    showLoader(true);
    getCompareStaticticsReportExel(body, showToast).then((response: any) => {
      showLoader(false);
      if (response) {
        response.blob().then((blob: any) => {
          if (blob && blob.size > 0) {
            const fileURL = window.URL.createObjectURL(blob);
            const elem = document.createElement('a');
            elem.href = fileURL;
            elem.download = 'report.xlsx';
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
          }
        });
      }
    });
  }
  const onGradeChange = useCallback(
    (values: any) => {
      setSelectedGrade(values!.value);
      setSelectedSubject('');
    },
    [setSelectedGrade, setSelectedSubject]
  );
  const onSubjectChange = useCallback(
    (values: any) => {
      setSelectedSubject(values!.value);
    },
    [setSelectedSubject]
  );
  const onDrawerClose = useCallback(() => {
    setBaseLineSurveyIds(null);
    setProgressSurveyIds(null);
    setDistinctGrades(null);
    onClose();
  }, [setBaseLineSurveyIds, setProgressSurveyIds, setDistinctGrades, onClose]);
  return (
    <Drawer
      title="Compare statistics report"
      onClose={onDrawerClose}
      open={isOpen}
      bodyStyle={{ padding: '0' }}
    >
      {!distinctGrades ? (
        <div className="flex-center w-100 h-100">Fetching grades...</div>
      ) : (
        <div className="w-100 h-100 flex-column">
          <div className="w-100 h-100" style={{ padding: '1rem' }}>
            {gradeOptions && (
              <div className={styles.reportTemplateContainer}>
                <label className={styles.widthFifty}>Grades :</label>
                <div style={{ width: '52%' }}>
                  <Select
                    value={{
                      label: selectedGrade,
                      value: selectedGrade,
                    }}
                    options={gradeOptions}
                    placeholder="Select grade"
                    onChange={(values: any) => onGradeChange(values)}
                  />
                </div>
              </div>
            )}

            {gradeOptions && subjectOptions && (
              <div className={styles.reportTemplateContainer}>
                <label className={styles.widthFifty}>Subjects :</label>
                <div style={{ width: '52%' }}>
                  <Select
                    value={{
                      label: selectedSubject,
                      value: selectedSubject,
                    }}
                    options={subjectOptions}
                    placeholder="Select subject"
                    onChange={(values: any) => onSubjectChange(values)}
                  />
                </div>
              </div>
            )}
            {gradeOptions && subjectOptions && baselineSurveyIds && (
              <div className={styles.reportTemplateContainer}>
                <label className={styles.widthFifty}>
                  {'Baseline survey id :'}
                </label>
                <div style={{ width: '52%' }}>
                  <Select
                    isMulti
                    value={selectedBaselineSurveyId}
                    options={baselineSurveyIds}
                    placeholder="Select first surveyid"
                    onChange={(value: any) =>
                      setSelectedBaselineSurveyId(value)
                    }
                  />
                </div>
              </div>
            )}
            {gradeOptions && subjectOptions && progressSurveyIds && (
              <div className={styles.reportTemplateContainer}>
                <label className={styles.widthFifty}>
                  {'Progress survey id :'}
                </label>
                <div style={{ width: '52%' }}>
                  <Select
                    isMulti
                    value={selectedProgressSurveyId}
                    options={progressSurveyIds}
                    placeholder="Select second surveyid"
                    onChange={(value: any) =>
                      setSelectedProgressSurveyId(value)
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div
            className="flex-align-center "
            style={{
              justifyContent: 'space-between',
              borderTop: '1px solid lightgray',
              padding: '1rem',
            }}
          >
            <Button variant="secondary" onClick={onDrawerClose}>
              Close
            </Button>
            <Button variant="primary" onClick={() => onDownloadButtonClicked()}>
              Download
            </Button>
          </div>
        </div>
      )}
    </Drawer>
  );
}

export default CompareStatisticsReportDrawer;
